import React from 'react';
import { Link } from 'react-router-dom';
import { FaStar, FaHeart } from 'react-icons/fa';
import { getImageUrl, PLACEHOLDER_IMAGE } from '../utils/imageUrl';
import { useWishlist } from '../context/WishlistContext';
import './ProductCard.css';

const ProductCard = ({ produto, showWishlistHeart = true }) => {
  const notaMedia = produto.nota_media || 0;
  const estrelas = Math.round(notaMedia);
  const { toggle, isInWishlist } = useWishlist();
  const foto = (produto.fotos && produto.fotos[0]) || produto.foto;

  const handleWishlistClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggle(produto.id);
  };

  return (
    <div className="product-card">
      {showWishlistHeart && (
        <button
          type="button"
          className={`wishlist-heart ${isInWishlist(produto.id) ? 'active' : ''}`}
          onClick={handleWishlistClick}
          aria-label={isInWishlist(produto.id) ? 'Remover da lista de desejos' : 'Adicionar à lista de desejos'}
        >
          <FaHeart />
        </button>
      )}
      <Link to={`/produto/${produto.id}`} className="product-link">
        <div className="product-image">
          {foto ? (
            <img 
              src={getImageUrl(foto)} 
              alt={produto.nome}
              loading="lazy"
              onError={(e) => {
                e.target.src = getImageUrl(PLACEHOLDER_IMAGE);
              }}
            />
          ) : (
            <div className="no-image">Sem Imagem</div>
          )}
          {produto.preco_anterior && (
            <span className="discount-badge">
              -{Math.round((1 - produto.preco / produto.preco_anterior) * 100)}%
            </span>
          )}
        </div>
        <div className="product-info">
          <h3 className="product-name">{produto.nome}</h3>
          <div className="product-rating">
            {[...Array(5)].map((_, i) => (
              <FaStar 
                key={i} 
                className={i < estrelas ? 'star-filled' : 'star-empty'} 
              />
            ))}
            <span className="rating-text">({produto.total_avaliacoes || 0})</span>
          </div>
          <div className="product-price">
            {produto.preco_anterior && (
              <span className="old-price">R$ {parseFloat(produto.preco_anterior).toFixed(2)}</span>
            )}
            <span className="current-price">R$ {parseFloat(produto.preco).toFixed(2)}</span>
          </div>
          {produto.estoque_quantidade !== undefined && (
            <div className="stock-info">
              {produto.estoque_quantidade > 0 ? (
                <span className="in-stock">Em estoque ({produto.estoque_quantidade})</span>
              ) : (
                <span className="out-of-stock">Fora de estoque</span>
              )}
            </div>
          )}
        </div>
      </Link>
    </div>
  );
};

export default ProductCard;

